import { render, staticRenderFns } from "./PlanDescription.vue?vue&type=template&id=c69e2f0c&scoped=true"
import script from "./PlanDescription.vue?vue&type=script&lang=js"
export * from "./PlanDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69e2f0c",
  null
  
)

export default component.exports